import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import { _AbcTreeComponent, _AbcTreeNode } from '@barthauer/abc/ui-components';
import { AbcArenaService } from '../../abc-arena.service';
import { Command } from './navigation.model';
import {
  NavigationGroupViewModel,
  NavigationLayoutViewModel,
  NavigationNodeBaseViewModel,
} from './navigation.viewModel';

@Component({
  selector: 'arena-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
  standalone: false,
})
export class NavigationComponent implements AfterViewChecked {
  @ViewChild('abcTree', { static: true }) abcTree: _AbcTreeComponent;
  @ViewChild('groupCaptionElement', { static: false }) groupCaptionElement!: ElementRef;

  @Input() rtlEnabled: boolean;

  public groupCaption: string;
  public loadExternalComponent: (command: Command) => Promise<void> = (identifier) => Promise.resolve();
  public loadLayout: (layout: NavigationLayoutViewModel) => Promise<void> = (layout) => Promise.resolve();
  public onCurrentNodeChanging: (currentNode: NavigationNodeBaseViewModel) => boolean = (n) => true;
  public onCurrentNodeChanged: (currentNode: NavigationNodeBaseViewModel) => void = (n) => {};
  public currentNode: NavigationNodeBaseViewModel;
  public currentGroup: NavigationGroupViewModel;

  protected isEllipsisApplied: boolean = false;

  constructor(
    private abcArenaService: AbcArenaService,
    private cdr: ChangeDetectorRef
  ) {}

  public loadArenaNavigationGroup(group: NavigationGroupViewModel): void {
    this.abcTree.idExpr = 'name';
    this.abcTree.createTreeNodeMethod = (element: NavigationNodeBaseViewModel) => {
      const node = new _AbcTreeNode();
      node.caption = element.caption;
      node.id = element.name;
      node.data = element;
      return node;
    };
    this.abcTree.getChildrenMethod = (element: NavigationNodeBaseViewModel) =>
      element instanceof NavigationGroupViewModel ? element.nodes : undefined;

    this.currentGroup = group;
    this.groupCaption = group?.caption;
    this.abcTree.data = group?.nodes;
    this.currentNode = group;
  }

  ngAfterViewChecked() {
    if (this.groupCaptionElement && this.groupCaptionElement.nativeElement) {
      this.detectEllipsis();
      this.cdr.detectChanges();
    }
  }

  detectEllipsis() {
    const element = this.groupCaptionElement.nativeElement;
    this.isEllipsisApplied = element.scrollWidth > element.clientWidth;
  }
  private getNodeId(node: NavigationNodeBaseViewModel) {
    const parts = node?.fullName?.split('\\');
    return parts?.slice(1)?.join('_');
  }

  public expandToNode(node: NavigationNodeBaseViewModel, select: boolean): void {
    const nodeId = this.getNodeId(node);
    if (nodeId) {
      this.expandNodes(nodeId);
      if (select) {
        this.currentNode = node;
        this.highlightNodeById(nodeId);
      }
    }
  }

  private expandNodes(nodeId: string) {
    setTimeout(() => {
      const node = this.abcTree.getNodeById(nodeId);
      this.expandItem(node);
    }, 0);
  }

  private setCurrentNode(node: NavigationNodeBaseViewModel): boolean {
    let changeNode: boolean = true;
    if (this.onCurrentNodeChanging) {
      changeNode = this.onCurrentNodeChanging(node);
    }
    if (changeNode) {
      this.currentNode = node;
      this.highlightNodeById(this.getNodeId(node));
      if (this.onCurrentNodeChanged) {
        this.onCurrentNodeChanged(node);
      }
    }
    return changeNode;
  }

  expandItem(node: _AbcTreeNode) {
    this.abcTree.instance.expandItem(node);
  }

  async nodeClick(node: _AbcTreeNode) {
    const layoutOrGroup = <NavigationNodeBaseViewModel>node.data;
    if (this.setCurrentNode(layoutOrGroup)) {
      if (layoutOrGroup instanceof NavigationGroupViewModel) {
        this.expandItem(node);
      } else if (layoutOrGroup instanceof NavigationLayoutViewModel) {
        const layout = layoutOrGroup;
        if (this.abcArenaService?.crudPermissions) {
          this.abcArenaService.crudPermissions = null;
        }
        if (layout) {
          if (layout?.command) {
            await this.loadExternalComponent(layout.command);
          } else {
            await this.loadLayout(layout);
          }
        }
      }
    }
  }

  private highlightTimeoutId: number;
  private highlightNodeById(nodeId: string): void {
    clearTimeout(this.highlightTimeoutId);
    const firstChildInListItem = document.querySelector(`li[data-item-id="${nodeId}"]`)?.firstChild;
    if (firstChildInListItem instanceof HTMLElement) {
      this.highlightNodeElement(firstChildInListItem);
    } else {
      this.highlightTimeoutId = window.setTimeout(() => {
        this.highlightNodeById(nodeId);
      }, 100);
    }
  }

  private highlightNodeElement(itemElement: HTMLElement): void {
    //https://supportcenter.devexpress.com/Ticket/Details/T224423/dxtreeview-losing-selected-item-backgroud-when-losing-focus
    if (document.getElementsByClassName('currently-active-item')[0]) {
      document.getElementsByClassName('currently-active-item')[0].classList.remove('currently-active-item');
    }
    itemElement.classList.add('currently-active-item');
  }
}
